import { MenuItem, Select } from "@mui/material";
import { SelectInputProps } from "@mui/material/Select/SelectInput";
import { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface PeerPageProps extends HTMLAttributes<HTMLDivElement> {
    value: number;
    handleChange: SelectInputProps['onChange']
}

export function PeerPage({ value, handleChange, ...rest }: PeerPageProps) {
    return (
        <div className={twMerge("tw-flex tw-items-center tw-gap-4", rest.className)}>
            <span className="tw-text-[#565656]">Resultados por página</span>
            <Select
                value={value}
                onChange={handleChange}
                size="small"
                sx={{
                    '.MuiOutlinedInput-notchedOutline': {
                        borderRadius: '10px',
                    },
                }}
                className="tw-h-[34px]"
            >
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
            </Select>
        </div>
    )
}